// Density / graphics / text / icons choices for the Motion Director (chat card + sync popup).
// Static grids: every option keeps the same size, border and weight, so a click only
// recolours (owner rule: no reflow).

import React from "react";
import i18n from "../../../../locales/i18n";

const DENSITY_OPTIONS = [
  ["key", "aideaChat.motion.densityKey"],
  ["full", "aideaChat.motion.densityFull"],
];
const GRAPHICS_OPTIONS = [
  ["minimal", "aideaChat.motion.graphicsMinimal"],
  ["balanced", "aideaChat.motion.graphicsBalanced"],
  ["rich", "aideaChat.motion.graphicsRich"],
];
const TEXT_OPTIONS = [
  ["auto", "aideaChat.motion.textAuto"],
  ["extract", "aideaChat.motion.textExtract"],
  ["add", "aideaChat.motion.textAdd"],
];
const ICON_OPTIONS = [
  ["auto", "aideaChat.motion.iconsAuto"],
  ["yes", "aideaChat.motion.iconsYes"],
  ["no", "aideaChat.motion.iconsNo"],
];

export function MotionChoice({ labelKey: groupLabelKey, options, cols, value, onChange }) {
  return (
    <>
      <p className="tw-m-0 tw-mt-2 tw-text-[12px] tw-leading-snug tw-text-[var(--aidea-muted-fg)]">
        {i18n.t(groupLabelKey)}
      </p>
      <div
        role="radiogroup"
        aria-label={i18n.t(groupLabelKey)}
        className={`tw-mt-1 tw-grid ${cols} tw-gap-1.5`}
      >
        {options.map(([id, labelKey]) => {
          const on = value === id;
          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => onChange(id)}
              className={`tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-px-2 tw-py-1.5 tw-text-center tw-text-[12.5px] tw-font-medium tw-transition-colors tw-duration-200 ${
                on
                  ? "tw-border-[var(--aidea-primary)] tw-bg-[var(--aidea-primary-tint)] tw-text-[var(--aidea-primary)]"
                  : "tw-border-[var(--aidea-border)] tw-bg-[var(--aidea-surface)] tw-text-[var(--aidea-fg)] hover:tw-bg-[var(--aidea-muted-bg)]"
              }`}
            >
              {i18n.t(labelKey)}
            </button>
          );
        })}
      </div>
    </>
  );
}

/**
 * The groups for `value = { density, graphics, text, icons }`; `onChange(next)` gets the full object.
 * `withText={false}` hides the Text group (Sync with AI always lifts the image text).
 */
export function MotionChoices({ value, onChange, withText = true }) {
  const set = (name) => (v) => onChange({ ...value, [name]: v });
  return (
    <>
      <MotionChoice
        labelKey="aideaChat.motion.densityLabel"
        options={DENSITY_OPTIONS}
        cols="tw-grid-cols-2"
        value={value.density}
        onChange={set("density")}
      />
      <MotionChoice
        labelKey="aideaChat.motion.graphicsLabel"
        options={GRAPHICS_OPTIONS}
        cols="tw-grid-cols-3"
        value={value.graphics}
        onChange={set("graphics")}
      />
      {withText && (
        <MotionChoice
          labelKey="aideaChat.motion.textLabel"
          options={TEXT_OPTIONS}
          cols="tw-grid-cols-3"
          value={value.text}
          onChange={set("text")}
        />
      )}
      <MotionChoice
        labelKey="aideaChat.motion.iconsLabel"
        options={ICON_OPTIONS}
        cols="tw-grid-cols-3"
        value={value.icons}
        onChange={set("icons")}
      />
    </>
  );
}
